export enum ContextModalEnum {
    SUCCESS="SUCCESS",
    ERROR="ERROR",
    WARNING="WARNING",
    INFO="INFO"
}